import { motion } from 'framer-motion';
import clsx from 'clsx';

interface AnimatedProgressBarProps {
  progressPercentage: number;
  className?: string;
  barClassName?: string;
  innerBarClassName?: string;
}

export default function AnimatedProgressBar({
  progressPercentage,
  className = '',
  barClassName = '',
  innerBarClassName = '',
}: AnimatedProgressBarProps) {
  return (
    <div className={className}>
      <div
        className={clsx(
          'h-[6px] tablet:h-8 bg-off-white rounded tablet:rounded-none overflow-hidden',
          barClassName,
        )}
      >
        <motion.div
          className={clsx(
            'h-full bg-mint rounded tablet:rounded-none tablet:rounded-tr-[8px] tablet:rounded-br-[8px]',
            progressPercentage >= 100 && 'rounded',
            innerBarClassName,
          )}
          initial={{ width: 0 }}
          animate={{ width: `${progressPercentage > 1 ? progressPercentage : 0.5}%` }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
      </div>
    </div>
  );
}
